export default __webpack_public_path__ + "1a1f095e57077875716e179c13df748d.png";